var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"player-container"},[_c('div',{ref:"player",staticClass:"playericon",class:[
      {
        //you: loginbackend.sessionId && player.id && player.id === loginbackend.playerId,
        you: _vm.player.id && _vm.player.isTalkingFlag,
        darken: _vm.isApplier,
        dead: _vm.player.isDead
      },
      _vm.player.role.team,
    ]},[(_vm.player.isST)?_c('Token',{attrs:{"role":_vm.player.role},on:{"set-role":function($event){return _vm.acceptPlayer()}}}):_c('Token',{attrs:{"role":_vm.displayRole},on:{"set-role":function($event){return _vm.acceptPlayer()}}})],1),_c('div',{ref:"player",staticClass:"name",on:{"click":function($event){return _vm.acceptPlayer()}}},[_c('span',[_vm._v(_vm._s(_vm.player.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }